import React from 'react';

import { convertDateToLocal } from '@utils/Util';

import CommonImage from '@/components/CommonImage';

const EtdDateFilter = ({ uniqueDeliveryDates, handleDateSelection, selectedDate, dateFlag = 'F' }) => {
	return (
		<div className="etd-date-filter ml-3">
			<div className="form-group mb-0 d-flex align-items-center align-self-center">
				<div className="select-component" style={{ width: '140px' }}>
					<div className="click-box click mb-1" data-toggle="dropdown" tabIndex={0}>
						<p className="regular-14 ">
							{selectedDate === 'All'
								? selectedDate
								: convertDateToLocal(selectedDate, 'DD MMM YY')}
						</p>
						<CommonImage src="/images/chevron_down.svg" />
					</div>
					<div data-testid="wrapper">
						<ul className="dropdown-box dropdown-menu-right  dropdown-menu">
							<li onClick={() => handleDateSelection('All')}>
								<span className="single-item-focus" tabIndex={0}>
									All
								</span>
							</li>
							{uniqueDeliveryDates.map((item, index) => (
								<li
									className={`single-item ${item === selectedDate ? 'active' : ''}`}
									onClick={() => handleDateSelection(item)}
									key={index}
								>
									<span className="single-item-focus" tabIndex={0}>
										{dateFlag}: {convertDateToLocal(item, 'DD MMM YY')}
									</span>
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
};

export default EtdDateFilter;
